/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Credits_Tab_GrantInputs */

const en_settings_credits_tab_grant = /** @type {(inputs: Settings_Credits_Tab_GrantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grant`)
};

/**
* | output |
* | --- |
* | "Grant" |
*
* @param {Settings_Credits_Tab_GrantInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_credits_tab_grant = /** @type {((inputs?: Settings_Credits_Tab_GrantInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Credits_Tab_GrantInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_credits_tab_grant(inputs)
});
export { settings_credits_tab_grant as "settings.credits.tab_grant" }